import { API } from './axios';

export const getFormPage = async slug => {
  const { data } = await API.get(`/${slug}`);
  return data;
};

export const submitForm = async ({ slug, fields, hp, tracking }) => {
  const { data } = await API.post(`/${slug}/submit`, { fields, hp, tracking });
  return data;
};

// Pix do envio. A cobrança é criada em segundo plano (o Asaas leva três
// chamadas), então a tela de conclusão consulta por token até ficar pronta.
export const getFormPayment = async ({ slug, token }) => {
  const { data } = await API.get(`/${slug}/payment`, { params: { token } });
  return data;
};

export const uploadFormFile = async ({ slug, file }) => {
  const body = new FormData();
  body.append('file', file);
  const { data } = await API.post(`/${slug}/uploads`, body, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

// Best-effort draft save so a lead who typed a phone/email but abandoned the
// form before hitting "Enviar" is not lost. Fire-and-forget by contract — the
// caller (App.vue) never awaits/surfaces errors from this. Returns the axios
// base URL so callers that need `navigator.sendBeacon` (survives tab close,
// unlike fetch/axios) can build the same request themselves.
export const submitPartialForm = async ({ slug, fields, hp }) => {
  const { data } = await API.post(`/${slug}/submit`, {
    fields,
    hp,
    partial: true,
  });
  return data;
};

export const partialFormSubmitUrl = slug =>
  `${API.defaults.baseURL}/${slug}/submit`;

// F3.2 — envia um lote de eventos ANÔNIMOS de analytics (view/start/
// step_completed/submit). Fire-and-forget: o caller nunca aguarda nem trata
// erro. `eventsUrl` permite ao App.vue usar navigator.sendBeacon no unload.
export const trackFormEvents = async ({
  slug,
  session,
  events,
  hp,
  variant,
}) => {
  const { data } = await API.post(`/${slug}/events`, {
    session,
    events,
    hp,
    variant,
  });
  return data;
};

export const formEventsUrl = slug => `${API.defaults.baseURL}/${slug}/events`;
